module.exports = __webpack_public_path__ + "static/media/no-offers.5edbb7c9.svg";